import { ThemeProvider } from 'styled-components';
import { CookiesProvider } from 'react-cookie';
import { LiveChatLoaderProvider } from 'react-live-chat-loader';

import { theme } from 'styled/theme';

import type { ComponentType, FC, ReactNode } from 'react';
import type { Theme } from 'styled/types';

//  default is our production app-id
const intercomAppId = process.env.INTERCOM_APP_ID || 'tv6jsyee';

const ThemeProviderComponent = ThemeProvider as ComponentType<{
  theme: Theme;
  children: ReactNode;
}>;

/** These are providers, expected to used in `gatsby-browser` and `gatsby-ssr` to wrap all of Gatsby. */
export const Providers: FC<{ children: ReactNode }> = ({ children }) => (
  <CookiesProvider>
    <LiveChatLoaderProvider providerKey={intercomAppId} provider="intercom">
      <ThemeProviderComponent theme={theme}>{children}</ThemeProviderComponent>
    </LiveChatLoaderProvider>
  </CookiesProvider>
);
